import { z } from 'zod';

export const FpvSettingsSchema = z.object({
    gamepadId: z.string(),
    rcOrder: z.array(z.number()).length(10),
    rcReverse: z.array(z.number()).length(10)
});

export type FpvSettingsData = z.infer<typeof FpvSettingsSchema>;

const RTCIceServerSchema = z.object({
    urls: z.union([z.string(), z.array(z.url())]),
    username: z.string().optional(),
    credential: z.string().optional()
});

export const IceConfigSchema = z.object({
    iceServers: z.array(RTCIceServerSchema),
    ws: z.string(),
    wsToken: z.string()
});

export type IceConfigData = z.infer<typeof IceConfigSchema>;

export interface FpvGetFpvSettingsRequestData {
    imei: string;
    gamepadId: string;
}

export interface FpvSaveFpvSettingsRequestData {
    imei: string;
    gamepadId: string;
    rcOrder?: number[];
    rcReverse?: number[];
}
